import FetchFacilities from '@Application/Facilities/Facilities/Queries/FetchFacilities';
import fetchFacilities from '@Application/Facilities/Facilities/fetchFacilities';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/**
 * Reads the current organization's agencies, fetching them when the slice does not hold them yet.
 * The server only sends agency ids on a staff member: this is what lets the card, the filters and the
 * sidebar resolve agency names.
 */
const useOrganizationFacilities = () => {
	const dispatch = useDispatch();
	const { currentOrganization } = useCurrentOrganization();
	const organizationId = currentOrganization?.id ?? null;

	return useStoreQuery({
		selector: (state) => state.facilitiesStore.facilities,
		stopOn: (value) => value !== null && value.organizationId === organizationId,
		query: () => {
			if (organizationId === null) {
				return Promise.resolve();
			}

			return dispatch(fetchFacilities(new FetchFacilities(organizationId)));
		},
		deps: [organizationId],
	});
};

export default useOrganizationFacilities;
